import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Page, SeverityBadge, Empty } from "./_shared";
import { Button } from "@/components/ui/button";
import { Bell, X, AlertTriangle, PackageX } from "lucide-react";
import { toast } from "sonner";
import { Skeleton } from "@/components/ui/skeleton";

export default function Alerts() {
  const [alerts, setAlerts] = useState(null);

  const load = () => api.get("/alerts").then((r) => setAlerts(r.data));
  useEffect(() => { load(); }, []);

  const dismiss = async (id) => {
    await api.post(`/alerts/${id}/dismiss`);
    setAlerts(alerts.filter((a) => a.id !== id));
    toast.success("Alerta dispensado");
  };

  return (
    <Page title="Alertas inteligentes" subtitle="Priorizamos o que requer sua atenção agora.">
      {!alerts ? (
        <div className="space-y-3">{Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-20" />)}</div>
      ) : alerts.length === 0 ? (
        <Empty title="Tudo sob controle 🎯" desc="Nenhum alerta ativo no momento. Sua operação está saudável." />
      ) : (
        <div className="space-y-3">
          {alerts.map((a) => {
            const Icon = a.type === "stockout" ? AlertTriangle : PackageX;
            const accent = a.severity === "critical" ? "border-red-500/30" : a.severity === "high" ? "border-orange-500/30" : "border-yellow-500/30";
            return (
              <div key={a.id} data-testid={`alert-${a.id}`} className={`p-5 rounded-xl border bg-card flex items-start gap-4 ${accent}`}>
                <div className="w-10 h-10 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0">
                  <Icon className="w-4 h-4 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <div className="font-medium">{a.title}</div>
                    <SeverityBadge severity={a.severity} />
                  </div>
                  <div className="text-sm text-muted-foreground mt-1">{a.description}</div>
                </div>
                <Button data-testid={`dismiss-${a.id}`} variant="ghost" size="icon" onClick={() => dismiss(a.id)}>
                  <X className="w-4 h-4" />
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </Page>
  );
}
